export enum QueryKeys {
  API_CLIENTS = 'api-clients',
  API_CLIENT = 'api-client',

  AUDIT_LOGS = 'audit-logs',

  FACILITIES = 'facilities',
  USER_FACILITIES = 'user-facilities',
  FACILITY = 'facility',
  CREATE_FACILITY = 'create-facility',
  EDIT_FACILITY = 'edit-facility',
  ADMIN_FACILITIES = 'admin-facilities',

  FACILITY_DOCTORS = 'facility-doctors',

  SUBSCRIPTION_INFO = 'subscription-info',

  SPECIALIZATIONS = 'specializations',
}
